module.exports = __webpack_public_path__ + "img/6.bb2160cb.png";